module.exports = __webpack_public_path__ + "static/media/en-data-roaming-iphone_4.4f198ec0.png";